import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from 'vue'
import { PPTChartElement } from '@/types/slides'

import BaseChartElement from './BaseChartElement.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenChartElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTChartElement>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseChartElement, {
    class: "screen-element-chart",
    elementInfo: __props.elementInfo
  }, null, 8, ["elementInfo"]))
}
}

})